import { DividendPayoutDraft } from '../components/DividendPayoutConfirmations';

interface PartitionedPendingPayouts {
    active: DividendPayoutDraft[];
    stale: DividendPayoutDraft[];
}

export const partitionPendingPayoutsByHeldSymbols = (
    payouts: DividendPayoutDraft[],
    heldSymbols: Set<string>
): PartitionedPendingPayouts => {
    return payouts.reduce<PartitionedPendingPayouts>(
        (acc, payout) => {
            if (heldSymbols.has(payout.symbol.toUpperCase())) {
                acc.active.push(payout);
            } else {
                acc.stale.push(payout);
            }
            return acc;
        },
        { active: [], stale: [] }
    );
};
